import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { add, deleteRecord, fetch, update } from '../services/MetersService';
import { Meter } from '../types';

export const useMeter = (meterId?: string) => {
    const queryClient = useQueryClient();

    // FETCH
    const meterQuery = useQuery({
        queryKey: ['meter', meterId],
        queryFn: () => fetch(meterId!),
        enabled: !!meterId
    });

    // CREATE MUTATION
    const createMutation = useMutation({
        mutationFn: (values: Meter) => {
            const { createdByUsername, created, updated, ...rest } = values;
            return add(rest);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['meters'] });
        }
    });

    // UPDATE MUTATION
    const updateMutation = useMutation({
        mutationFn: (values: Meter) => {
            if (!meterId) throw new Error('meterId is required parameter');
            const { createdByUsername, created, updated, ...rest } = values;
            return update(meterId, rest);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['meters'] });
            queryClient.invalidateQueries({ queryKey: ['meter', meterId] });
        }
    });

    // DELETE MUTATION
    const deleteMutation = useMutation({
        mutationFn: () => {
            if (!meterId) throw new Error('meterId is required parameter');
            return deleteRecord(meterId);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['meters'] });
        }
    });

    return {
        record: meterQuery.data,
        loading: meterQuery.isLoading,
        fetchRecord: meterQuery.refetch,
        createRecord: createMutation.mutate,
        updateRecord: updateMutation.mutate,
        deleteRecord: deleteMutation.mutate,
        createMutation,
        updateMutation,
        deleteMutation
    };
};